exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Example Media queries\n *\n * @media (max-width: @kng-screen-xs-max) { ... }\n * @media (min-width: @kng-screen-sm-min) and (max-width: @kng-screen-sm-max) { ... }\n * @media (min-width: @kng-screen-md-min) and (max-width: @kng-screen-md-max) { ... }\n * @media (min-width: @kng-screen-lg-min) { ... }\n *\n */\n.kingdom-list .filters .form-group {\n  margin-bottom: 0;\n}\n.kingdom-list .filters .world-filter {\n  display: inline-block;\n  margin-left: 20px;\n}\n.kingdom-list .filters .search-filter {\n  display: inline-block;\n  width: 250px;\n}\n.kingdom-list .filters .more-filters-link {\n  display: inline-block;\n  margin-left: 15px;\n}\n.kingdom-list .filters .add-resource-link {\n  float: right;\n  line-height: 35px;\n}\n.kingdom-list .resource-item {\n  padding: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/resources/list/list.component.less
// module id = ../../../../../src/app/components/resources/list/list.component.less
// module chunks = main